<template>
  <v-container fluid>
    <v-toolbar color="blue-grey darken-3">
      <h2 class="headline white--text"> <v-icon class="white--text">mdi-arrow-left-right</v-icon> Konfigurationsoptionen pro Eintrag</h2>
    </v-toolbar>
    <br />
    <v-btn
      color="blue-grey darken-1 white--text"
      rounded
      large
      @click="showNewDialog = true"
    >
      <v-icon>mdi-cog</v-icon>
      Neue Konfiguration
    </v-btn>
    <br />
    <v-card
      style="width: 50%"
    >
      <v-toolbar
        color="blue-grey darken-2"
        dark
      >
        <v-toolbar-title>Configuration options</v-toolbar-title>

      </v-toolbar>
      <v-list>
        <v-list-item
          v-for="item in metadataDefinitions"
          :key="item.name"
          @click="selectMetadataDefinition(item)"
        >
          <v-list-item-content>
            <v-list-item-title v-text="item.name"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
    <v-dialog v-model="showDeleteDialog" :persistent="true" max-width="500px">
      <v-card>
        <v-card-text>
          <h3>Sind Sie sicher, dass Sie diesen Eintrag löschen möchten?</h3>
        </v-card-text>
        <v-card-actions>
          <v-btn color="default" text @click="metadataDefinitionNameToDelete = null">Nein</v-btn>
          <v-btn color="primary" text @click="confirmDelete" >
            Ja
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showNewDialog" :persistent="true"  max-width="850px">
      <metadata-definition
        v-if="showNewDialog"
        @cancel="showNewDialog = false"
        @save="saveTimeRecordingMetadataDefinition"
      />
    </v-dialog>
    <v-dialog v-model="showEditDialog" :persistent="true"  max-width="850px">
      <metadata-definition
        v-if="showEditDialog"
        :initialName="selectedMetadataDefinition.name"
        :initialType="selectedMetadataDefinition.type"
        :initialMandatory="selectedMetadataDefinition.mandatory"
        :initialDigitNumber="selectedMetadataDefinition.digitNumber"
        :initialValueOptions="selectedMetadataDefinition.valueOptions"
        @cancel="selectedMetadataDefinition = null"
        @save="saveTimeRecordingMetadataDefinition"
        @delete="selectMetadataDefinitionForDelete"
      />
    </v-dialog>
  </v-container>
</template>

<script>

import timeparkApi from '../../timeparkApi';
import MetadataDefinition from './MetadataDefinition'

export default {
  name: 'TimeRecordingMetadataDefinitions',
  components: {
    MetadataDefinition,
  },
  watch: {
  },
  mounted() {
  },
  computed: {
    showEditDialog() {
      return !!this.selectedMetadataDefinition;
    },
    showDeleteDialog() {
      return !!this.metadataDefinitionNameToDelete;
    },
    metadataDefinitions() {
      return this.$store.state.timeRecordingMetadataDefinitions;
    }
  },
  methods: {
    selectMetadataDefinitionForDelete(name) {
      this.selectedMetadataDefinition = null;
      this.metadataDefinitionNameToDelete = name;
    },
    selectMetadataDefinition(m) {
      this.selectedMetadataDefinition = m;
    },
    async saveTimeRecordingMetadataDefinition(metadataDefinition) {
      try {
        this.showNewDialog = false;
        this.selectedMetadataDefinition = null;

        const apiResult = await timeparkApi.saveOrUpdateTimeRecordingMetadataDefinition(metadataDefinition);
        this.$store.commit('setTimeRecordingMetadataDefinitions', apiResult.data);
      } catch (err) {
        window.console.error(err);
      }
    },
    async confirmDelete() {
      const apiResult = await timeparkApi.deleteTimeRecordingMetadataDefinition(this.metadataDefinitionNameToDelete);

      this.metadataDefinitionNameToDelete = null;
      this.$store.commit('setTimeRecordingMetadataDefinitions', apiResult.data);
    }
  },
  data: () => ({
    showNewDialog: false,
    metadataDefinitionNameToDelete: null,
    selectedMetadataDefinition: null,
  }),
};
</script>
